import React from 'react';
import './LoadingFallback.css';

/**
 * Loading fallback for code-split routes
 * Shows while lazy-loaded components are downloading
 * 
 * Story 2.4: Implement Route-Based Code Splitting for Cards
 * 
 * This component displays during chunk download (<500ms target).
 * Provides user feedback and prevents flash of empty content.
 * 
 * Usage with React.lazy() and Suspense:
 * 
 * <Suspense fallback={<LoadingFallback message="Loading cards..." />}>
 *   <LazyCardsListPage />
 * </Suspense>
 * 
 * @param {string} message - Loading message to display (default: 'Loading...')
 */
function LoadingFallback({ message = 'Loading...' }) {
  return (
    <div className="loading-fallback">
      <div className="loading-spinner" />
      <p className="loading-message">{message}</p>
    </div>
  );
}

export default LoadingFallback;
